<p-card
	[header]="'presentation.app.page.profile.coach.sectors.header' | translate"
	styleClass="h-48"
>
	<div class="h-full relative">
		<ng-scrollbar
			class="absolute w-full h-full top-0 left-0"
			track="vertical"
			visibility="hover"
		>
			<div class="space-y-1">
				<div
					*ngFor="let sector of sectors; let isLast = last"
					class="text-sm flex items-center space-x-3"
				>
					<i class="fas fa-caret-right"></i>
					<span>
						{{ 'presentation.app.common.coach.sectors.' + sector | translate }}
					</span>
				</div>
			</div>
		</ng-scrollbar>
	</div>
</p-card>
